import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HourlyRequestFilteredReferentialsIds } from '@scenario/models/hourly-request-filtered-referentials-ids.model';

export interface HourlyRequestFilteredReferentialsIdsState {
  filteredZoneIds: number[];
  filteredSourceIds: number[];
  filteredBasecaseIds: number[];
  filteredWeatherYearIds: number[];
  isFetching: boolean;
  error?: string;
}

export const initialState: HourlyRequestFilteredReferentialsIdsState = {
  filteredZoneIds: [],
  filteredSourceIds: [],
  filteredBasecaseIds: [],
  filteredWeatherYearIds: [],
  isFetching: false,
};

export const hourlyRequestFilteredReferentialsIdsSlice = createSlice({
  name: 'hourlyRequestFilteredReferentialsIds',
  initialState,
  reducers: {
    retrieveHourlyRequestFilteredReferentialsIds: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: PayloadAction<{ inactiveFields: string[]; filteredReferentialsIds: HourlyRequestFilteredReferentialsIds }>,
    ) => {
      state.isFetching = true;
    },
    retrieveHourlyRequestFilteredReferentialsIdsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    retrieveHourlyRequestFilteredZoneIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredZoneIds = action.payload;
      state.isFetching = false;
    },
    retrieveHourlyRequestFilteredSourceIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredSourceIds = action.payload;
      state.isFetching = false;
    },
    retrieveHourlyRequestFilteredBasecaseIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredBasecaseIds = action.payload;
      state.isFetching = false;
    },
    retrieveHourlyRequestFilteredWeatherYearIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredWeatherYearIds = action.payload;
      state.isFetching = false;
    },
  },
});

export const {
  retrieveHourlyRequestFilteredReferentialsIds,
  retrieveHourlyRequestFilteredReferentialsIdsFailure,
  retrieveHourlyRequestFilteredZoneIdsSuccess,
  retrieveHourlyRequestFilteredSourceIdsSuccess,
  retrieveHourlyRequestFilteredBasecaseIdsSuccess,
  retrieveHourlyRequestFilteredWeatherYearIdsSuccess,
} = hourlyRequestFilteredReferentialsIdsSlice.actions;

export default hourlyRequestFilteredReferentialsIdsSlice.reducer;
